import { FormItem, Input, Label, TextField } from '@lemonenergy/lemonpie-3'
import type { ComponentProps } from 'react'
import { useState } from 'react'

import ErrorHintText from '~/components/ui/ErrorHintText'

const EyeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
)

const EyeOffIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c6.5 0 10 8 10 8a13.16 13.16 0 0 1-1.67 2.68" />
    <path d="M6.61 6.61A13.53 13.53 0 0 0 2 12s3.5 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
    <path d="m2 2 20 20" />
  </svg>
)

export type PasswordFieldProps = ComponentProps<typeof Input> & {
  label: string
  error?: string
}

export const PasswordField = ({
  id,
  label,
  error,
  ...inputProps
}: PasswordFieldProps) => {
  const [visible, setVisible] = useState(false)

  return (
    <FormItem state={error ? 'error' : undefined}>
      <TextField>
        <Label htmlFor={id}>{label}</Label>
        <div className="relative">
          <Input
            id={id}
            type={visible ? 'text' : 'password'}
            className="pr-larger"
            {...inputProps}
          />
          <button
            type="button"
            onClick={() => setVisible((current) => !current)}
            aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
            aria-pressed={visible}
            className="absolute right-small top-1/2 -translate-y-1/2 fg-soft hover:fg-main"
          >
            {visible ? <EyeOffIcon /> : <EyeIcon />}
          </button>
        </div>
      </TextField>
      <ErrorHintText error={error} />
    </FormItem>
  )
}

export default PasswordField
